"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrc = void 0;
var easyCrc_sidecar_1 = require("@dive/to-engine/easyCrc-sidecar");
var diveSpells_sidecar_1 = require("./diveSpells-sidecar");
function getCrc() {
    var e_1, _a;
    var _b = easyCrc_sidecar_1.easyCrc.create('spells'), add = _b.add, getCrc = _b.getCrc;
    try {
        // TODO: sort by id?
        for (var _c = __values(diveSpells_sidecar_1.diveSpells.getAll()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var c = _d.value;
            if (c.isDead) {
                continue;
            }
            add(c.id);
            add(c.delayTicksLeft);
            // console.log('get crc spells++')
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var v = getCrc();
    // console.log('crc spells', v)
    return v;
}
exports.getCrc = getCrc;
